const saveByteArray = (reportName, byte, type) => {
	const blob = new Blob([byte], { type });
	const link = document.createElement('a');
	link.href = window.URL.createObjectURL(blob);
	link.download = reportName;
	link.click();
}

export default saveByteArray;
